module.exports = __webpack_public_path__ + "media/alert_sound4.88e24d69.mp3";